// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginHeader_root__6_BV8"};